module.exports = __webpack_public_path__ + "img/img21.0aa466e2.png";